import api from './Axios';
import { toast } from 'react-toastify';

/**
 * Send appointment email
 * @param {Object} formData - Appointment form data
 * @returns {Promise<boolean>} - Success status
 */
export const sendAppointmentEmail = async (formData) => {
  try {
    // Try backend API first
    const response = await api.post('/api/appointments', {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      department: formData.department,
      message: formData.message || 'No message provided',
      date: new Date().toISOString()
    });

    if (response.status === 200 || response.status === 201) {
      return true;
    }
  } catch (error) {
    console.log('Backend API not available, trying EmailJS...');
    
    // Try EmailJS if available
    try {
      if (window.emailjs && process.env.REACT_APP_EMAILJS_SERVICE_ID) {
        await window.emailjs.send(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
          {
            to_email: 'ehtishamglt@gmail.com',
            to_name: 'Aman Medical Complex',
            from_name: formData.name,
            from_email: formData.email,
            phone: formData.phone,
            department: formData.department,
            message: formData.message || 'No message provided',
            reply_to: formData.email
          },
          process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        );
        return true;
      }
    } catch (emailjsError) {
      console.error('EmailJS error:', emailjsError);
    }

    // Fallback: Use mailto
    const subject = encodeURIComponent(`Appointment Request - ${formData.department}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\n` +
      `Email: ${formData.email}\n` +
      `Phone: ${formData.phone}\n` +
      `Department: ${formData.department}\n` +
      `Message: ${formData.message || 'No message provided'}\n\n` +
      `Date: ${new Date().toLocaleString()}`
    );
    
    window.location.href = `mailto:ehtishamglt@gmail.com?subject=${subject}&body=${body}`;
    return false; // Return false to indicate fallback was used
  }
  
  return false;
};

/**
 * Send confirmation email to patient
 */
export const sendConfirmationEmail = async (patientEmail, patientName, department) => {
  // This would typically be handled by backend
  // But can also use EmailJS for confirmation
  try {
    if (window.emailjs && process.env.REACT_APP_EMAILJS_SERVICE_ID) {
      await window.emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_CONFIRMATION_TEMPLATE_ID,
        {
          to_email: patientEmail,
          to_name: patientName,
          department: department
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );
    }
  } catch (error) {
    console.error('Confirmation email error:', error);
  }
};
